
export class Validatedata {
    static validateEmail(email) {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})?$/;

        const validDomains = ['com', 'net', 'org', 'edu', 'gov', 'mil', 'co', 'info', 'biz', 'vn'];

        if (!emailRegex.test(email)) {
            return false;
        }

        const domainPart = email.split('@')[1];
        const domainExtension = domainPart.split('.').pop();

        return validDomains.includes(domainExtension);
    }
    static isStrongPassword(password) {
        const minLength = 12;
        const hasUpper = /[A-Z]/.test(password);
        const hasLower = /[a-z]/.test(password);
        const hasDigit = /\d/.test(password);
        const hasSpecial = /[!@#$%^&*(),.?":{}|<>]/.test(password);

        return password.length >= minLength && hasUpper && hasLower && hasDigit && hasSpecial;
    }
    static validatePhoneNumber(phone) {
        const phoneRegex = /^(0[1-9]{1}[0-9]{8})$/;
        return phoneRegex.test(phone);
    }
    static validateEduEmail(email) {
        const eduEmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.edu\.vn$/;
        return eduEmailRegex.test(email);
    }
}